// export const API_URL = 'https://mirror-transport.mirror.edunixsystem.com/'
// export const API_URL = 'https://transport-api.motherland.edunixsystem.com/'
// export const API_URL = 'https://bus-api.rowadalmustakbal.edunixsystem.com/'
// export const API_URL = 'https://transport-api.albayan-schools.com/'
// export const API_URL = 'https://bus-api.alnukhbeh-edu.com/'
// export const API_URL = 'https://bus-api.qimmah.edunixsystem.com/'

// New driverAssistant API (JWT auth, trip-based endpoints) - see DriverAssistant-API-Contract.md
export const CORE_API_URL = 'https://web-api.mirror.edunixsystem.com/api/v1'

export const FIREBASE_CONFIG = {
	apiKey: 'AIzaSyD4ZIw8kGgNDHHeBEL8UJrENbp-am_-kpo',
	authDomain: 'edunix-web.firebaseapp.com',
	projectId: 'edunix-web',
	storageBucket: 'edunix-web.firebasestorage.app',
	messagingSenderId: '1019827642622',
	appId: '1:1019827642622:web:b9135aae7375c0303ac5af'
}

export const FIREBASE_VAPID_KEY = 'BNQYkirnwpnGbj-yHqYk_sOL3U3g972BEVUi0YbtSfPk847PrfvTAu8FjFZWQlwQc2rtyQh8O2vv1N1rIFBqLWs'
